import React from 'react';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { UserName } from '../name_component/user/UserNameComponent';

require('./FieldTechRowDisplay.less');

export const FieldTechRowDisplay: React.FC<any> = ({ fieldTech, ...props }) => (
	<div className="fieldTechRowDisplay" {...props}>
		<div className="fieldTechRowDisplay__rowTitle">
			<div className="flex flex-row items-center">
				<ContactAvatar userType="supplier" contact={fieldTech.supplierContact} />
				<div className="ml-4 flex flex-col">
					<span>
						<UserName mode={'inline'} userType="supplier" contact={fieldTech.supplierContact} />
					</span>
				</div>
			</div>
		</div>
	</div>
);
